import CheckboxStyled from "@/components/CheckboxStyled";
import {useUniversityDegrees} from "@/lib/api";
import {Spinner} from "@/components/Spinner";
import InputLabelStyled from "@/components/InputLabelStyled";
import {Box} from "@mui/system";
import {useState} from "react";

export default function UniversityDegreeSelector({name, onChange}) {
    const { universityDegrees, isLoading, isError } = useUniversityDegrees();
    const [ selectedValues, setSelectedValues ] = useState([]);

    const handleCheckboxChanged = (event) => {
        const { name: id, checked } = event.target;

        let newValues = [];
        for (const v of selectedValues) {
            if (v.id !== id) {
                newValues = [...newValues, v];
            }
        }
        newValues = [...newValues, {id: id, value: checked}];

        setSelectedValues(newValues);

        if (onChange && typeof onChange === "function") {
            const fakeEvent = {
                target: {
                    name: name,
                    value: newValues
                }
            };
            onChange(fakeEvent, newValues);
        }
    };

    if (isLoading) {
        return <Spinner />
    }

    return (
        <>
            <Box sx={style}>
                <InputLabelStyled label="Abschlüsse"/>
            </Box>
            {universityDegrees.map((ud, idx) => (
                <CheckboxStyled
                    key={ud.id}
                    label={ud.name}
                    name={ud.id}
                    onChange={handleCheckboxChanged}
                    marginTop
                />
            ))}
        </>
    )
}

const style = {
    marginBottom: -0.5,
}
